var React = require('react');

function LogOut (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M36 84H20C17.8783 84 15.8434 83.1571 14.3431 81.6569C12.8429 80.1566 12 78.1217 12 76V20C12 17.8783 12.8429 15.8434 14.3431 14.3431C15.8434 12.8429 17.8783 12 20 12H36","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M64 68L84 48L64 28","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M84 48H36","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

LogOut.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = LogOut;

LogOut.default = LogOut;
